module.exports = "::ng-deep blockquote {\r\n    margin-left: 1rem;\r\n    background: #eee;\r\n    padding: 20px;\r\n}\r\n::ng-deep blockquote:before {\r\n    content: '„';\r\n    color: #999;\r\n    font-size: 40px;\r\n}\r\n::ng-deep blockquote:after {\r\n    content: '“';\r\n    color: #999;\r\n    font-size: 40px;\r\n    line-height: 0;\r\n    position: relative;\r\n    top: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/view-note/view-note.component.css
// module id = ./src/app/notes/view-note/view-note.component.css
// module chunks = main